<template>
    <div v-if="showModal">

        <b-modal
                v-model="showModalLocal"
                :title="'Передача путевки'"
                class="modal-primary"
                size="md"
                ok-variant="primary"
                @hide.prevent
                @ok="handleOk"
                @cancel="handleCancel"
                @close="handleCancel"
                ref="my-modal"
        >

            <b-alert show variant="danger">
            Вы планируете передать путевку другому агенту. После выполнения этого действия агент {{ voucherx.user_firstname }}
            {{ voucherx.user_lastname }} (#{{ voucherx.user_id }}) утратит права доступа к этой путевке.

            <br/>Передача путевки возможно только внутри агентства.
            </b-alert>

            <b-alert show variant="success">
                Возможно кроме "передать путевку" надо "предоставить доступ" ? То есть что бы другой агент мог работать с путевкой
                без смены владельца ?
            </b-alert>

            <b-form-group label="Агент: "  :label-cols="3" :horizontal="false   ">
                <div class="input-group">
                    <b-form-select
                       :plain="true"
                       v-model="newUser"
                       :options="getUsers"
                       value-field="id"
                       text-field="full_name"
                       value="Please select">
                    </b-form-select>
                </div>
            </b-form-group>

            <b-form-group label="Комментарий: " :label-cols="3" :horizontal="false">
                <div class="input-group">
                    <b-textarea
                        v-model="comment"
                    ></b-textarea>
                </div>
            </b-form-group>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отказаться от затеи
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Передать путевку
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions_loaders } from '@/functions_loaders';
    import { functions } from '@/functions';

    export default {
        name: 'ChangeUserDialog',
        mixins: [functions, functions_loaders, ],
        data: function () {
            return {
                newUser:null,
                comment:null,
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            voucherx: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                //console.log('SimpleDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                //console.log('SimpleDialog: handleOk');
                this.$emit("changeuser", {newwuser:this.newUser, comment:this.comment});
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                //console.log('SimpleDialog: handleSubmit');
                this.$emit("changeuser", {newwuser:this.newUser, comment:this.comment});
                this.$emit("hide", false);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },
            getUsers: function () {
                return this.$store.state.user.company.users;
            },
        },
        created: function() {
            //console.log('SimpleDialog: created');
        },
        mounted: function() {
        },
        updated: function() {
        },
    }
</script>
